'use strict';

var _AutoNumeric = require('./AutoNumeric');

var _AutoNumeric2 = _interopRequireDefault(_AutoNumeric);

var _AutoNumericOptions = require('./AutoNumericOptions');

var _AutoNumericOptions2 = _interopRequireDefault(_AutoNumericOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-unused-vars: 0 */

/**
 * The defaults options.
 * These can be overridden by the following methods:
 * - HTML5 data attributes (ie. `<input type="text" data-currency-symbol=" €">`)
 * - Options passed to the `update` method (ie. `anElement.update({ currencySymbol: ' €' });`), or simply during the initialization (ie. `new AutoNumeric(domElement, { options });`)
 */
/**
 * Default settings for autoNumeric.js
 * @author Alexandre Bonneau <alexandre.bonneau@linuxfr.eu>
 * @copyright © 2016 Alexandre Bonneau
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sub license, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

_AutoNumeric2.default.defaultSettings = {
  allowDecimalPadding: _AutoNumeric2.default.options.allowDecimalPadding.always,
  alwaysAllowDecimalCharacter: _AutoNumeric2.default.options.alwaysAllowDecimalCharacter.doNotAllow,
  caretPositionOnFocus: _AutoNumeric2.default.options.caretPositionOnFocus.doNoForceCaretPosition,
  createLocalList: _AutoNumeric2.default.options.createLocalList.createList,
  currencySymbol: _AutoNumeric2.default.options.currencySymbol.none,
  currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.prefix,
  decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
  decimalCharacterAlternative: _AutoNumeric2.default.options.decimalCharacterAlternative.none,
  decimalPlaces: _AutoNumeric2.default.options.decimalPlaces.two,
  decimalPlacesRawValue: _AutoNumeric2.default.options.decimalPlacesRawValue.useDefault,
  decimalPlacesShownOnBlur: _AutoNumeric2.default.options.decimalPlacesShownOnBlur.useDefault,
  decimalPlacesShownOnFocus: _AutoNumeric2.default.options.decimalPlacesShownOnFocus.useDefault,
  defaultValueOverride: _AutoNumeric2.default.options.defaultValueOverride.doNotOverride,
  digitalGroupSpacing: _AutoNumeric2.default.options.digitalGroupSpacing.three,
  digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.comma,
  divisorWhenUnfocused: _AutoNumeric2.default.options.divisorWhenUnfocused.none,
  emptyInputBehavior: _AutoNumeric2.default.options.emptyInputBehavior.focus,
  eventBubbles: _AutoNumeric2.default.options.eventBubbles.bubbles,
  eventIsCancelable: _AutoNumeric2.default.options.eventIsCancelable.isCancelable,
  failOnUnknownOption: _AutoNumeric2.default.options.failOnUnknownOption.ignore,
  formatOnPageLoad: _AutoNumeric2.default.options.formatOnPageLoad.format,
  formulaMode: _AutoNumeric2.default.options.formulaMode.disabled,
  historySize: _AutoNumeric2.default.options.historySize.medium,
  isCancellable: _AutoNumeric2.default.options.isCancellable.cancellable,
  leadingZero: _AutoNumeric2.default.options.leadingZero.deny,
  maximumValue: _AutoNumeric2.default.options.maximumValue.tenTrillions,
  minimumValue: _AutoNumeric2.default.options.minimumValue.tenTrillions,
  modifyValueOnWheel: _AutoNumeric2.default.options.modifyValueOnWheel.modifyValue,
  negativeBracketsTypeOnBlur: _AutoNumeric2.default.options.negativeBracketsTypeOnBlur.none,
  negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.none,
  negativeSignCharacter: _AutoNumeric2.default.options.negativeSignCharacter.hyphen,
  noEventListeners: _AutoNumeric2.default.options.noEventListeners.addEvents,
  //TODO Shouldn't we use `truncate` as the default value?
  onInvalidPaste: _AutoNumeric2.default.options.onInvalidPaste.error,
  outputFormat: _AutoNumeric2.default.options.outputFormat.none,
  overrideMinMaxLimits: _AutoNumeric2.default.options.overrideMinMaxLimits.doNotOverride,
  positiveSignCharacter: _AutoNumeric2.default.options.positiveSignCharacter.plus,
  rawValueDivisor: _AutoNumeric2.default.options.rawValueDivisor.none,
  readOnly: _AutoNumeric2.default.options.readOnly.readWrite,
  roundingMethod: _AutoNumeric2.default.options.roundingMethod.halfUpSymmetric,
  saveValueToSessionStorage: _AutoNumeric2.default.options.saveValueToSessionStorage.doNotSave,
  selectNumberOnly: _AutoNumeric2.default.options.selectNumberOnly.selectNumbersOnly,
  selectOnFocus: _AutoNumeric2.default.options.selectOnFocus.select,
  serializeSpaces: _AutoNumeric2.default.options.serializeSpaces.plus,
  showOnlyNumbersOnFocus: _AutoNumeric2.default.options.showOnlyNumbersOnFocus.showAll,
  showPositiveSign: _AutoNumeric2.default.options.showPositiveSign.hide,
  showWarnings: _AutoNumeric2.default.options.showWarnings.show,
  styleRules: _AutoNumeric2.default.options.styleRules.none,
  suffixText: _AutoNumeric2.default.options.suffixText.none,
  symbolWhenUnfocused: _AutoNumeric2.default.options.symbolWhenUnfocused.none,
  unformatOnHover: _AutoNumeric2.default.options.unformatOnHover.unformat,
  unformatOnSubmit: _AutoNumeric2.default.options.unformatOnSubmit.keepCurrentValue,
  valuesToStrings: _AutoNumeric2.default.options.valuesToStrings.none,
  watchExternalChanges: _AutoNumeric2.default.options.watchExternalChanges.doNotWatch,
  wheelOn: _AutoNumeric2.default.options.wheelOn.focus,
  wheelStep: _AutoNumeric2.default.options.wheelStep.progressive
};

Object.freeze(_AutoNumeric2.default.defaultSettings);
Object.defineProperty(_AutoNumeric2.default, 'defaultSettings', { configurable: false, writable: false });